import { inAppGtm } from '@/lib/gtm'

export default function () {
  if (!process.server) {
    inAppGtm();
  }
}